import { IPromise } from 'angular';
import * as _ from 'underscore';

import { ResultHelper } from '../helpers/ResultHelper';
import { Module } from '../Module';
import { DeleteAllVersionContentOnSiteRequest } from '../ServerApi/requests/DeleteAllVersionContentOnSiteRequest';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { ServerService } from './ServerService';
import { ToasterService, ToastType } from './ToasterService';

export class ClearSavedRevisionsAction {

  public static $inject = [
    '$translate',
    '$q',
    '$rootScope',
    'ConfirmActionDialog',
    'ServerService'
  ];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private $q: ng.IQService,
    private $rootScope: ng.IRootScopeService,
    private ConfirmActionDialog: ConfirmActionDialog,
    private serverService: ServerService
  ) { }

  public confirmDeleteSiteRevisions(siteId: string): IPromise<any> {
    const confirmActionDialogInstance = this.ConfirmActionDialog.open({
      scope: this.$rootScope.$new(true),
      title: this.$translate.instant('clearSavedRevisions'),
      bodyText: this.$translate.instant('clearSavedRevisionsConfirmMessage'),
      actionName: this.$translate.instant('clearSavedRevisionsConfirmButton'),
      isDeleteAction: true,
      action: (confirmActionDialogInstance: IConfirmActionDialogInstance) => {
        return this.serverService.sendRequest(new DeleteAllVersionContentOnSiteRequest({ siteId: siteId }))
          .then(ResultHelper.rejectResultOnError(this.$q))
          .then(_.identity, () => confirmActionDialogInstance.showErrorMessage(this.$translate.instant('clearSavedRevisionsError')));
      }
    });

    confirmActionDialogInstance.result.then((result: any) => {
      ToasterService.instance.pop({ type: ToastType.Info, text: this.$translate.instant('clearSavedRevisionsSuccess') });
    });

    return confirmActionDialogInstance.result;
  }

}

Module.instance().service('ClearSavedRevisionsAction', ClearSavedRevisionsAction);
